import Section, {Props} from './Section';

export {Props as SectionProps};
export default Section;
